// Definitions taken from API
// eslint-disable-next-line no-shadow
export enum Role {
  Admin = 'ROLE_ELMO_ADMIN',
  CAdmin = 'ROLE_SUPER',
  Super = 'ROLE_ELMO_SUPER',
  Migration = 'ROLE_ELMO_MIGRATION',
}
